import { routeCreator } from '../../../helpers/routing/routeCreator'
import preview from "../../../pages/preview/preview";
import issueschecklists from "../pages/checklists/issueschecklists";
import Create from '../pages/create/create'
import Edit from '../pages/edit/edit'
import Index from "../pages/index";

const BASE_KEY = 'page.issues.'

export const ROUTE_PAGE_ISSUES_CREATE = routeCreator(Create, '/issue/create', 'Create', BASE_KEY + 'create', { exact: true })

export const ROUTE_PAGE_ISSUES_EDIT = routeCreator(Edit, '/issue/edit/:IssueId', 'Edit', BASE_KEY + 'edit')
export const ROUTE_PAGE_ISSUES_INDEX = routeCreator(Index, '/issues', 'Index', BASE_KEY + 'index')
export const ROUTE_PAGE_ISSUE_CHECKLISTS = routeCreator(issueschecklists, '/issues-checklists/:IssueId/:Description', 'issuesChecklists', BASE_KEY + 'issuesChecklists')
export const ROUTE_PAGE_QUESTIONNAIRE_PREVIEW_BY_HEADER = routeCreator(preview, '/checklist-by-header/:headerId', 'preview', BASE_KEY + 'preview')
export const ROUTE_PAGE_QUESTIONNAIRE_PREVIEW = routeCreator(preview, '/checklist-preview/:questionnaireId/{:headerId}', 'preview', BASE_KEY + 'preview')


const router = {
    ROUTE_PAGE_ISSUES_CREATE,
    ROUTE_PAGE_ISSUES_EDIT,
    ROUTE_PAGE_ISSUES_INDEX,
    ROUTE_PAGE_ISSUE_CHECKLISTS,
    ROUTE_PAGE_QUESTIONNAIRE_PREVIEW_BY_HEADER,
    ROUTE_PAGE_QUESTIONNAIRE_PREVIEW
}

export default router